import { Button, DATE_FORMAT } from '@dev-spendesk/grapes';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useLocalStorage } from 'react-use';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { useUser } from 'modules/app/hooks/useUser';
import { useGetBillingMigration } from 'modules/company/billing/components/CompanyPlan/hooks/useGetBillingMigration';
import { TopBanner } from 'src/core/common/components/TopBanner/TopBanner';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routeFor, routes } from 'src/core/constants/routes';
import { LocalStorageKey } from 'src/core/constants/storage';

export const PriceUpdateNotification = () => {
  const companyId = useCompanyId();
  const user = useUser();
  const { t, localeFormat } = useTranslation('global');

  const history = useHistory();

  const [priceUpdateNotificationSeen, setPriceUpdateNotificationSeen] =
    useLocalStorage<boolean>(LocalStorageKey.PriceUpdateBanner);
  const isAoOrAdmin = user.is_account_owner || user.is_admin;
  const isTargetedForPriceUpdateBanner =
    isAoOrAdmin && !priceUpdateNotificationSeen;
  const billingMigrationQueryState = useGetBillingMigration(
    companyId,
    isTargetedForPriceUpdateBanner,
  );

  if (
    !isTargetedForPriceUpdateBanner ||
    billingMigrationQueryState.status !== 'success' ||
    !billingMigrationQueryState.data?.migrationPending
  ) {
    return null;
  }

  const openBillingMigrationModal = () => {
    setPriceUpdateNotificationSeen(true);
    history.push(
      `${routeFor(routes.COMPANY_BILLING_PLAN.path, {
        company: companyId,
      })}?priceUpdatePage=true`,
    );
  };

  return (
    <TopBanner
      variant="info"
      title={t('billing.companyPlan.priceUpdateBanner', {
        dueDate: localeFormat(
          new Date(billingMigrationQueryState.data.migrationPlan.migrationDate),
          DATE_FORMAT.MEDIUM,
        ),
      })}
    >
      <div>
        <Button
          variant="tertiaryNeutral"
          text={t('misc.close')}
          onClick={() => setPriceUpdateNotificationSeen(true)}
        />
        <Button
          variant="secondaryNeutral"
          onClick={openBillingMigrationModal}
          text={t('misc.learnMore')}
        />
      </div>
    </TopBanner>
  );
};
